import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from '../../components/successMessage';
import FailedMessage from '../../components/FailedMessage';
import useApiUrls from "../../useApiUrls";

const AddSerialnoMQTTSetting = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const { getUrlByOperation, error: urlError } = useApiUrls();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = getCookie("token");
  const userid = getCookie("userid");

  // Updated state to hold all required form data
  const [formData, setFormData] = useState({
    remark: "",
    active: true,
    deviceid: "1",
    json: "{}"
  });

  // Handle input change for text and select fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "active" ? value === "true" : value,
    }));
  };

  // Handle JSON input with validation
  const handleJsonChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      json: value,
    }));
  };

  // Handle device ID change
  const handleDeviceIdChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      deviceid: value,
    }));
  };

  // Function to check if JSON is valid
  const isJsonValid = (jsonString) => {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (error) {
      return false;
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Get token and userId from cookies


    if (!token || !userid) {
      console.error("Missing token or userId in cookies");
      setMessage("Failed to add Json Setting. Missing authentication.");
      setIsSubmitting(false);
      return;
    }

    try {
      // Fix 1: Convert deviceid to number instead of string
      const deviceIdNum = parseInt(formData.deviceid, 10);

      // Fix 2: Parse the JSON string if it's valid JSON, or use empty object as fallback
      let jsonData;
      try {
        jsonData = isJsonValid(formData.json) ? JSON.parse(formData.json) : {};
      } catch (e) {
        jsonData = {};
      }

      // Prepare the data to be sent with fixes applied
      const apiData = {
        remark: formData.remark.trim(), // Trim whitespace from remark
        active: formData.active === "true" || formData.active === true,
        deviceid: isNaN(deviceIdNum) ? 1 : deviceIdNum, // Use number, default to 1 if parsing fails
        json: jsonData // Send as parsed object instead of string
      };

      console.log("Sending data to API:", JSON.stringify(apiData, null, 2));

      // Make API call
      // Fix 3: Change Content-Type to application/json
      const response = await axios.post(
        'https://api.dqr-display-tms.eventum.co.in/api/DeviceJsonSettingOperation/Insert',
        apiData,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json", // Changed from application/json-patch+json
          },
        }
      );

      // Handle the response
      if (response.data && response.data.isresponse && response.data.responsestatus === "SUCCESS") {
        setMessage("MQTT Setting added successfully!");

        // Clear form
        setFormData({
          remark: "",
          active: true,
          deviceid: "1",
          json: "{}"
        });

        // Navigate after delay
        setTimeout(() => {
          navigate("/mqttSetting");
        }, 3000);
      } else {
        setMessage(`Failed to add Json Setting: ${response.data?.errormsg || "Unknown error"}`);
        console.error("API Response:", response.data);
      }
    } catch (error) {
      console.error("Error adding MQTT Setting:", error);
      console.error("Error details:", error.response?.data);
      setMessage(`Failed to add Json Setting: ${error.response?.data?.errormsg || error.message || "Server error"}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Add Serial No Mqtt Setting</h1>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add Json Setting</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter description..."
                                name="remark"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active.toString()}
                                onChange={handleChange}
                              >
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Serial ID</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.deviceid}
                                onChange={handleDeviceIdChange}
                                placeholder="Enter serial ID..."
                                name="deviceid"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>JSON Configuration</label>
                              <textarea
                                className={`form-control ${!isJsonValid(formData.json) && formData.json !== "{}" ? "is-invalid" : ""}`}
                                value={formData.json}
                                onChange={handleJsonChange}
                                placeholder="Enter JSON configuration..."
                                name="json"
                                rows="4"
                              ></textarea>
                              {!isJsonValid(formData.json) && formData.json !== "{}" && (
                                <div className="invalid-feedback">
                                  Please enter valid JSON format
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-info mr-2"
                                onClick={() => {
                                  // Get the latest value and copy to clipboard
                                  fetch('https://api.dqr-display-tms.eventum.co.in/api/DeviceJsonSettingOperation/PublishId', {
                                    method: 'GET',
                                    headers: {
                                      'accept': 'text/plain',
                                      'UserId': userid,
                                      'X-Authorization': token
                                    }
                                  })
                                    .then(response => response.json())
                                    .then(data => {
                                      if (data && data.value) {
                                        navigator.clipboard.writeText(data.value);
                                        // Create publishId object properly
                                        const publishObject = { publishId: data.value };
                                        const jsonString = JSON.stringify(publishObject, null, 2);
                                        setFormData(prev => ({
                                          ...prev,
                                          json: jsonString
                                        }));
                                        setMessage(`Publish ID (${data.value}) copied and added to JSON field!`);
                                        setTimeout(() => setMessage(""), 3000);
                                      }
                                    })
                                    .catch(error => {
                                      console.error("Error fetching publish ID:", error);
                                      setMessage("Failed to get publish ID");
                                    });
                                }}
                              >
                                Get Publish ID
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer mt-3">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                            disabled={!isJsonValid(formData.json) || isSubmitting}
                          >
                            {isSubmitting ? "Adding..." : "Add"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message === "MQTT Setting added successfully!" ? (
        <SuccessMessage message={message} />
      ) : message.startsWith("Failed to add Json Setting") ? (
        <FailedMessage message={message} />
      ) : message ? (
        <div className="alert alert-info alert-dismissible fade show" role="alert">
          {message}
          <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => setMessage("")}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      ) : null}
    </>
  );
};

export default AddSerialnoMQTTSetting;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}